import {createContext, useContext} from 'react'

const DowntimePlantIdContext = createContext<string | null>(null)

type DowntimePlantIdProviderProps = {
  plantId: string
  children: React.ReactNode
}

export const DowntimePlantIdProvider: React.FC<DowntimePlantIdProviderProps> = ({
  plantId,
  children
}) => {
  return (
    <DowntimePlantIdContext.Provider value={plantId}>{children}</DowntimePlantIdContext.Provider>
  )
}

export const useDowntimePlantId = () => {
  const plantId = useContext(DowntimePlantIdContext)

  if (!plantId) {
    throw new Error('Downtime plantId missing from feature context')
  }

  return plantId
}
